import { getAdminOrganisation } from '@modv/sdk'

const state = {
  organisations: [],
  organisationsLoading: false
}
const getters = {}
const mutations = {
  set_organisations_loading(state, val) {
    state.organisationsLoading = val
  },
  GET_ORGANISATIONS: (state, res) => {
    state.organisations = res.data.data.map((org) => {
      org.isSelect = false
      org.entityType = 'organisation'
      return org
    })
  },
  ADD_ORGANISATION: (state, res) => {
    state.organisations.push(res)
    state.total++
  },
  UPDATE_ORGANISATION: (state, params) => {
    const organisation = state.organisations.filter((x) => x._id === params.organisationId)[0]
    organisation.name = params.organisationName
  },
  REMOVE_ORGANISATION: (state, res) => {
    // Update organisation
    state.organisations = state.organisations.filter((x) => x._id !== res.organisationId)
    state.total--
  },
  CLEAR_SELECT_ENTITIES: (state) => {
    if (state.organisations) {
      state.organisations.forEach((element) => {
        element.isSelect = false
      })
    }
  },
  SET_ORGANISATION_SELECT: (state, org) => {
    if (state.organisations) {
      state.organisations.forEach((organisation) => {
        if (organisation._id === org._id) {
          organisation.isSelect = true
        }
      })
    }
  }
}
const actions = {
  async getOrganisations({ commit }) {
    commit('set_organisations_loading', true)
    commit('GET_ORGANISATIONS', await getAdminOrganisation())
    commit('set_organisations_loading', false)
  },
  addOrganisation({ commit }, params) {
    commit('ADD_ORGANISATION', {
      organisation: params.data.data
    })
  },
  removeOrganisation({ commit }, params) {
    commit('REMOVE_ORGANISATION', {
      organisationId: params.organisationId
    })
  },
  updateOrganisation({ commit }, params) {
    commit('UPDATE_ORGANISATION', { organisationId: params.organisationId, organisationName: params.name })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
